import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type ErrorNodeOptions = {} & SimpleManaNodeOptions

export default class ErrorNode extends SimpleManaNode {

	static nodeName = "Error node"
	static nodeDesc = "Catch errors with this node"
	static nodeIcon = '❌'
	static category = NodeCategories.Logistics
	static nodeType = 'ErrorNode'

	allowEntry(particle: ManaParticle) {
		return false
	}

	onScroll(dir: number) { }

	allowErrorEntry(particle: ManaParticle) {
		return true
	}

}